import React from 'react';
import { SEOTableData, TableConfig } from 'src/api/models/SEOTable';
import { HeadContainer, HeadRow } from './Head.styles';
import CellEntry, { getCellTemplateColumns } from './Cell';

type HeadProps = Pick<SEOTableData, 'head'> & TableConfig;

const Head = ({ head, ...rest }: HeadProps): JSX.Element => {
  const { columnCount, firstColumnCustomWidth } = rest;
  const templateColumns = getCellTemplateColumns(firstColumnCustomWidth, columnCount);

  return (
    <HeadContainer>
      <HeadRow templateColumns={templateColumns}>
        <CellEntry
          isEmpty
          rowIndex={0}
          isHead
          isTitle
          {...rest}
        />
        {head.map((item, index) => (
          <CellEntry
            key={index}
            text={item}
            rowIndex={0}
            isHead
            {...rest}
          />
        ))}
      </HeadRow>
    </HeadContainer>
  );
};

export default Head;
